import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Form, message, Row, Col, Select, Divider } from "antd";
import {
  CustomInput,
  CustomButton,
  CustomTitle,
  CustomSelect,
  CustomParagraph,
  CustomDynamicSelect,
} from "../../components";
import { Refresh } from "../../api's/auth";
import { useSpin } from "../../components/SpinContext";
import { gmtOptions, gmtToIanaMap, prefferedLanguages } from "../../common/static_data";
import {
  GetSettingsProfile,
  SubmitSettingsProfile,
} from "../../api's/settings";
//import { getDesignationDDL } from '../../common/utils/dropDown';
// import PhoneInput from "antd-phone-input";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from 'libphonenumber-js';
import CustomRadioGroup from "../../components/CustomRadioGroup";
import { useToken } from "../../common/helper";
import CustomCheckboxGroup from "../../components/CustomCheckboxGroup";
import TeamsTag from "../../components/TeamsTag";
import SettingsGDPR from "./SettingsGDPR";
import CircleGroup from "../Shipments/CircleGroup";

// import ReactFlagsSelect from "react-flags-select";
// import CountryList from "country-list-with-dial-code-and-flag";

const SettingsTeamBasedProfile = ({ title }) => {
  const [form] = Form.useForm();
  const { token, removeToken, saveLoginUser } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const [selectedGmt, setSelectedGmt] = useState("GMT");
  const handleGmtChange = (value) => {
    setSelectedGmt(value);
    form.setFieldsValue({ user_time_zone: value });
  };

  //const [desgnationDDL, setDesignationDDL] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [selectedTimeZone, setSelectedTimeZone] = useState("browser");
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [userTeams, setUserTeams] = useState([]);

  const navigate = useNavigate();
  const handleTimeZoneChange = (e) => {
    const value = e.target.value;
    setSelectedTimeZone(value);

    form.setFieldsValue({
      time_zone_enabled: value === "preferred",
      user_time_zone: value === "preferred" ? selectedGmt : null,
    });

    // ✅ Trigger validation when selecting "Preferred"
    if (value === "preferred") {
      form.validateFields(["user_time_zone"]);
    }

    if (value === "browser") {
      localStorage.removeItem("user_time_zone");
      setSelectedGmt(null);
    }
  };
  const teamData = {
    Hospital: { role: "Admin", color: "#EA9596" },
    Oncology: { role: "Member", color: "#CE95EA" },
  };

  // add country code and flag [mahtab]
  const [selectedCountryCode, setSelectedCountryCode] = useState();
  // const countryOptions = CountryList.getAll().reduce((acc, country) => {
  //   acc[country.code] = ` ${country.name} ${country.dial_code}`;
  //   return acc;
  // }, {});

  // const handleSelect = (isoCode) => {
  //   const country = CountryList.getAll().find((c) => c.code === isoCode);
  //   if (country) {
  //     setSelectedCountryCode(country);
  //   }
  // };
  // end country code and flag [mahtab]

  const onFinish = (values) => {
    const isSMSorWhatsAppSelected = selectedNotifications.some((opt) =>
      ["SMS", "WhatsApp"].includes(opt)
    );
    const phoneNumber = values.phone_number?.trim();
  
    if (isSMSorWhatsAppSelected) {
      if (!phoneNumber || phoneNumber === "") {
        message.error("Phone number is required when SMS or WhatsApp is selected.");
        return;
      }
      const cleaned = phoneNumber.replace(/[^\d]/g, "");
      const isValidPhone = /^\+[\d\s()-]+$/.test(phoneNumber) && cleaned.length >= 7;
  
      if (!isValidPhone) {
        message.error("Please enter a valid phone number if you want to enable opt-in notifications (SMS or WhatsApp).");

        return;
      }
    }
  
    if (selectedTimeZone === "preferred" && !selectedGmt) {
      message.error("Please select a time zone before saving.");
      return;
    }
  
    if (values && Object.keys(values).length > 0) {
      if (selectedCountryCode) {
        values.phone_number = selectedCountryCode?.phone;
      }
  
      values.time_zone_enabled = selectedTimeZone === "preferred";
      values.user_time_zone = selectedTimeZone === "preferred" ? selectedGmt : null;
  
      if (selectedTimeZone === "browser") {
        localStorage.removeItem("user_time_zone");
      } else {
        localStorage.setItem("user_time_zone", selectedGmt);
      }
  
      const mappedNotifications = selectedNotifications.map((option) => {
        if (option === "SMS") return "MOBILE";
        if (option === "WhatsApp") return "WHATSAPP";
        return option;
      });
  
      const model = {
        ...values,
        notification_options: mappedNotifications,
      };
  
      submitProfile(model);
    }
  };
  
  
  // useEffect(() => {
  //   getDesignationDDL(token).then((val) => {
  //     if (val && val.length > 0) {
  //       setDesignationDDL(val)
  //     }
  //   });
  // }, []);

  // const getDesignations = () => {
  //   GetDesignations(token)
  //     .then((res) => {
  //       const data = res?.data ? res.data : null;
  //       if (data) {
  //         if (data?.data?.is_success) {
  //           let resp = data?.data?.data.length > 0 ? data?.data?.data : [];
  //           if (resp.length > 0) {
  //             setDesignationDDL(resp)
  //           }

  //         } else {
  //           message.error(data?.data?.message);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       unauthorize(error)
  //     }).finally(() => {
  //       hideSpin();
  //     });

  // }

  //get Call
  useEffect(() => {
    fetchProfile();
  }, []);
  const notificationBackendToUI = {
    MOBILE: "SMS",
    WHATSAPP: "WhatsApp",
  };
  
  const fetchProfile = () => {
    showSpin();
    GetSettingsProfile(token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              form.setFieldsValue({
                id: resp.id,
                name: resp.name,
                email: resp.email,
                title: resp.title,
                // country_code:resp.country_code,
                phone_number: resp.phone_number,
                time_zone_enabled: resp.time_zone_enabled,
                user_time_zone: resp.user_time_zone,
                preferred_language: resp?.preferred_language || 'English(US)'
              });
              setSelectedTimeZone(
                resp.time_zone_enabled ? "preferred" : "browser"
              );
              setSelectedNotifications(
                (resp?.notification_options || []).map(
                  (opt) => notificationBackendToUI[opt] || opt
                )
              );
              setSelectedGmt(resp.user_time_zone || null);
              setUserTeams(resp?.teams || []);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  //submit call
  const submitProfile = (model) => {
    setIsFormValid(true);
    showSpin();

    SubmitSettingsProfile(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            message.success(data?.data?.message);
            localStorage.setItem("@token", res?.data?.data?.access_token);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  const validator = (_, { valid }) => {
    // if (valid(true)) return Promise.resolve(); // strict validation
    if (valid()) return Promise.resolve(); // non-strict validation
    return Promise.reject("Invalid phone number");
  };

  return (
    <>
      <CustomTitle
        text={title}
        fontSize={24}
        fontWeight="700"
        lineHeight="32px"
        color="#000"
        marginBottom={0}
      />

      <Form
        form={form}
        name="ProfileForm"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        initialValues={{
          name: "",
          id: null,
          email: "",
          phone_number: selectedCountryCode,
          designation: null,
          time_zone_enabled: "browser",
          user_time_zone: null,
          preferred_language: null,
        }}
      >
        <div style={{ marginBottom: "45px" }}>
          <Row gutter={14}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
              <Form.Item
                className="custom-input form-input-style"
                label="Name"
                name="name"
                rules={[
                  { required: true, message: "Please input your name" },
                  {
                    min: 3,
                    message: "Name must be at least 3 characters long",
                  },
                  {
                    pattern: /^[A-Za-z\s'-]+$/,
                    message: "Please enter a valid name (letters, spaces, hyphens only)",
                  },
                ]}
                style={{ marginBottom: "0px" }}
              >
                <CustomInput
                  placeholder="Enter name"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
              <Form.Item
                className="custom-input form-input-style"
                label="Role"
                name="title"
                rules={[
                  { required: true, message: "Please input your role" },
                  {
                    validator: (_, value) => {
                      if (value && value.trim() === "") {
                        return Promise.reject(
                          new Error("Only spaces are not allowed")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                style={{ marginBottom: "0px" }}
              >
                <CustomInput
                  placeholder="Enter your role"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={14} style={{ marginTop: "30px" }}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
              <Form.Item
                className="custom-input form-input-style"
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Enter valid email" },
                ]}
                style={{ marginBottom: "0px" }}
              >
                <CustomInput
                  placeholder="Enter email"
                  height="36px"
                  border="1px solid #E8E8E8"
                  bgColor="#Fff"
                  disabled={true}
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
              <Form.Item
                label={"Phone number (optional)"}
                name="phone_number"
                style={{ marginBottom: "0px" }}
                initialValue=""
                // rules={[
                //   {
                //     validator: (_, value) => {
                //       if (!value || value.trim() === "") {
                //         return Promise.resolve();  
                //       }
                //       const digitsOnly = value.replace(/\D/g, "");
                
                //       if (digitsOnly.length >= 10) {
                //         return Promise.resolve();
                //       }
                
                //       return Promise.reject(new Error("Please enter a valid phone number"));
                //     },
                //   },
                // ]}

                rules={[
                  {
                    validator: (_, value) => {
                      if (!value || value.trim() === '') {
                        return Promise.resolve(); // Optional
                      }
                      try {
                        if (isValidPhoneNumber(value)) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(new Error("Invalid phone number"));
                        }
                      } catch {
                        return Promise.reject(new Error("Invalid phone number"));
                      }
                    },
                  },
                ]}
                
              >
                <PhoneInput
                  country={"us"}
                  value={form.getFieldValue("phone_number")}
                  onChange={(value, countryData, e, formattedValue) => {
                    form.setFieldsValue({ phone_number: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={14} style={{ marginTop: "24px" }}>

             <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                          <Form.Item
                            className="custom-input form-input-style"
                            label="Preferred language"
                            name="preferred_language"
                            rules={[{ required: false, message: "Please select value" }]}
                            style={{ marginBottom: "0px" }}
                          >
                            <CustomDynamicSelect
                              placeholder="Select"
                              height="36px"
                              border="0px"
                              bgColor="#F3F3F3"
                              textColor="#5E5E5E"
                              borderRadius="8px"
                              placeholderColor="#5E5E5E"
                              lineHeight="38px"
                              // onChange={handleTemperatureRangeChange}
                              options={prefferedLanguages}
                            />
                          </Form.Item>
                          <CustomParagraph
              text={"AI-generated communications will be in this language"}
              fontSize="12px"
              fontWeight="400"
              lineHeight="20px"
              marginBottom="0"
              marginTop={'8px'}
              color={'#5e5e5e'}
            />
                        </Col>

          </Row>

          <Row
            gutter={14}
            gap={4}
            style={{
              marginTop: "24px",
              marginLeft: "0px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Row gutter={16}>
              <Col span={24}>
                <CustomTitle
                  marginBottom={"10px"}
                  text="Opt in for notifications via..."
                  fontSize={14}
                  fontWeight="600"
                />
                <CustomCheckboxGroup
                  options={["SMS", "WhatsApp"]}
                  selectedValues={selectedNotifications}
                  onChange={setSelectedNotifications}
                />
              </Col>
            </Row>

            {userTeams?.length > 0 && (
              <Row gutter={16} style={{ marginTop: "20px" }}>
                <Col span={24}>
                  <CustomTitle
                    text="Team"
                    fontSize={14}
                    fontWeight="600"
                    marginTop="10px"
                  />
                  <TeamsTag teamData={userTeams} />
                </Col>
              </Row>
            )}

            <Divider
              style={{
                marginTop: "14px",
                marginBottom: "14px",
                borderColor: "#D9D9D9",
              }}
            />
            <CustomParagraph
              text={"Display timestamps in..."}
              fontSize="12px"
              fontWeight="600"
              lineHeight="20px"
              marginBottom="20px"
            />
            <CustomRadioGroup
              value={selectedTimeZone}
              onChange={handleTimeZoneChange}
              options={[
                { value: "browser", label: "My browser time zone" },
                { value: "preferred", label: "Preferred time zone" },
              ]}
            />
            {selectedTimeZone === "preferred" && (
              <Form.Item
                style={{ marginTop: "30px" }}
                name="user_time_zone"
                label={
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#000",
                    }}
                  >
                    Preferred time zone
                  </span>
                }
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (getFieldValue("time_zone_enabled") && !value) {
                        return Promise.reject(
                          new Error("Please select a time zone")
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <CustomSelect
                  placeholder="Select Time Zone"
                  value={selectedGmt}
                  onChange={handleGmtChange}
                  fontSize={14}
                  lineHeight={"16px"}
                  fontWeight="600"
                  border="0px"
                  bgColor={"#F3F3F3"}
                  borderRadius={"40px"}
                  boxShadow={"none"}
                  height="36px"
                  options={gmtToIanaMap}
                  width="400px"
                  disabled={selectedTimeZone !== "preferred"}
                />
              </Form.Item>
            )}
          </Row>
        </div>
        <CustomButton
          text="Save"
          width={138}
          height={36}
          borderRadius={8}
          bgColor="#000"
          color="#fff"
          border="0px"
          fontSize={14}
          fontWeight={500}
          htmlType="submit"
          isFormValid={isFormValid}
        />
      </Form>
      {/* <div style={{width:'320px'}}>
      <SettingsGDPR />
</div> */}
    </>
  );
};

export default SettingsTeamBasedProfile;
